import React from "react";
import MidwestDentalProgressTracker from "../../components/progressTracker/MidwestDentalProgressTracker";

const MidwestDentalDisclaimerScreen = ({
  disclaimerConfig,
  onGoBack,
  onSubmit,
  steps,
  currentStep,
  deviceType,
  configs,
  firstName,
}) => {
  const {
    title = "",
    subtitle = "",
    paragraphText = "",
    message = "",
    contactPhone = "",
  } = disclaimerConfig || {};

  const displayName = firstName || "";

  return (
    <div className="midwest-dental-form-layout">
      {/* Fixed Header with Progress Tracker */}
      <div className="midwest-dental-fixed-header">
        <MidwestDentalProgressTracker
          steps={steps}
          currentStep={currentStep}
          deviceType={deviceType}
        />
      </div>

      {/* Scrollable Content */}
      <div className="midwest-dental-content-area">
        <div className="midwest-dental-disclaimer-card">
          {configs?.logo && (
            <div className="midwest-dental-disclaimer-logo-container">
              <img
                src={configs.logo}
                alt="Logo"
                className="midwest-dental-disclaimer-logo"
              />
            </div>
          )}

          <h2 className="midwest-dental-disclaimer-title">
            {title || `Thank you${displayName ? `, ${displayName}` : ""}! Please Call Our Office`}
          </h2>

          {subtitle && (
            <p className="midwest-dental-disclaimer-subtitle pt-[2px]">{subtitle}</p>
          )}

          <p className="midwest-dental-disclaimer-message pt-8">
            {paragraphText || message}
          </p>

          {contactPhone && (
            <span
             
              className="midwest-dental-disclaimer-call-btn mt-4"
            >
              Call at  <strong> {contactPhone} </strong>
            </span>
          )}
        </div>
      </div>

      {/* Fixed Footer - same pattern as FormRenderer */}
      <div className="bottom-bar-shadow">
        <div className="flex justify-between pt-3 m-auto bottom-bar w-full">
            <button className="text_button" onClick={onGoBack}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19 12H5M5 12L12 19M5 12L12 5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>Previous</span>
            </button>
            <div className="primary_button" onClick={onSubmit}>
              <span>Submit</span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 12H19M19 12L12 5M19 12L12 19"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
        </div>
      </div>
    </div>
  );
};

export default MidwestDentalDisclaimerScreen;
